/**
 * Distribución de teclado en español (España y Latinoamérica coinciden en las
 * teclas que importan acá), la que emulan algunos lectores: la Syble
 * XB-6266MBT del laboratorio manda la tecla física `Slash` para el guion,
 * porque en un teclado español el `-` está ahí.
 *
 * `caracterEs` es el espejo de `caracterUs`: devuelve el carácter que el
 * lector QUISO transmitir a partir de la tecla física (`KeyboardEvent.code`)
 * y Shift, si el lector emula un teclado español. Cubre los dígitos y la
 * puntuación del juego de caracteres de GS1; letras y cualquier otra tecla
 * devuelven null (misma razón que en `teclado-us.ts`).
 *
 * Sirve para el caso "PC en inglés + lector en español": la PC traduce la
 * tecla `Slash` como `/`, y esta tabla recupera el `-`. Cuál de las tres
 * interpretaciones (PC, US, español) es la correcta lo decide la lógica de
 * pickeo comparando contra los lotes del remito del ERP.
 */

const SIN_SHIFT: Readonly<Record<string, string>> = {
  Minus: "'",
  BracketRight: '+',
  Comma: ',',
  Period: '.',
  Slash: '-',
  IntlBackslash: '<',
  Space: ' ',
};

const CON_SHIFT: Readonly<Record<string, string>> = {
  Digit1: '!',
  Digit2: '"',
  Digit5: '%',
  Digit6: '&',
  Digit7: '/',
  Digit8: '(',
  Digit9: ')',
  Digit0: '=',
  Minus: '?',
  BracketRight: '*',
  Comma: ';',
  Period: ':',
  Slash: '_',
  IntlBackslash: '>',
  Space: ' ',
};

export function caracterEs(code: string, shift: boolean): string | null {
  const digito = /^Digit(\d)$/.exec(code)?.[1];
  if (digito && !shift) return digito;
  if (/^Key[A-Z]$/.test(code)) return null;
  return (shift ? CON_SHIFT : SIN_SHIFT)[code] ?? null;
}
